module.exports = __webpack_public_path__ + "img/10处废.a03f5d08.jpg";